var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('PageFaq',{attrs:{"faq-categories":_vm.faqCategories,"faq-questions":_vm.faqQuestions}})
}
var staticRenderFns = []

export { render, staticRenderFns }